import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
const Navigation = () => {

  const { t } = useTranslation();
  return (
    <div className="navigation">
      <ul>
        <NavLink to="/" className={(nav) => (nav.isActive ? "nav-active" : "")}>
        <li>{t("home")}</li>
        </NavLink>
        <NavLink
          to="/privacypolicy"
          className={(nav) => (nav.isActive ? "nav-active" : "")}
        >
          <li>{t("privacy_policy")}</li>
        </NavLink>
      </ul>
    </div>
  );
};

export default Navigation;
